module.exports = __webpack_public_path__ + "static/img/banner_login_4.548216f.png";


//////////////////
// WEBPACK FOOTER
// ./src/_app/wwka/src/assets/image/banner_login_4.png
// module id = UzeH
// module chunks = 63